import axios from "axios";
import { API } from "@/lib/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

export async function enablePush(slug, guestUserId = null) {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    throw new Error("Notifications aren't supported on this device.");
  }
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Notifications permission was denied.");

  const reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;

  const { data } = await axios.get(`${API}/public/hub/${slug}/vapid`);
  if (!data.public_key) throw new Error("Push is not configured for this hub.");

  const existing = await reg.pushManager.getSubscription();
  const sub =
    existing ||
    (await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.public_key),
    }));

  const payload = JSON.parse(JSON.stringify(sub));
  if (guestUserId) payload.guest_user_id = guestUserId;
  await axios.post(`${API}/public/hub/${slug}/push/subscribe`, payload);
  return true;
}

export function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}
